import "./AdvancedFiltersModal.scss"
import { Box, Button, IconButton, Modal, Typography } from "@mui/material"
import { IMapFilter } from "../../map-models"
import CloseIcon from '@mui/icons-material/Close';
import { BaseMapFilterEnum } from "../../../../shared/models/map_models";
import DateRageMapFilter from "../DateRageMapFilter/DateRangeMapFilter";
import ChipFilterInput from "../ChipFilterInput/ChipFilterInput";

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: "400px",
  width: "85%",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  padding: "5px"
};

interface IAdvancedFiltersModalProps {
    filters: Array<IMapFilter>
    showModal: boolean
    toggleModal: () => void
    filterValueChanged: (filter: IMapFilter, newValue: string) => void
}


export const AdvancedFiltersModal = (props: IAdvancedFiltersModalProps) => {

    const clearFilters = () => {
        props.filters.forEach((x) => {
            props.filterValueChanged(x, "")
        })
    }

    return (
        <Modal
            open={props.showModal}
            onClose={props.toggleModal}
        >
            <Box sx={modalStyle}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <div className="advanced-filters-modal-close-button-wrapper">
                        <IconButton
                            sx={{color: "text.secondary", padding: 0}}
                            size="small"
                            aria-controls="close"
                            aria-haspopup="true"
                            color="inherit"
                            onClick={props.toggleModal}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <Box sx={{padding: "10px", paddingTop: 0}}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Advanced Filters
                        </Typography>
                        <Typography 
                            id="modal-modal-description" 
                            className="advanced-filters-body" 
                            sx={{ mt: 2 }}
                        >
                            {props.filters.map((filter, i) => (
                                <div className="advanced-filter-input-wrapper" key={i}>
                                    {filter.type === BaseMapFilterEnum.CHIP &&
                                        <ChipFilterInput 
                                            label={filter.name}
                                            value={typeof filter.value === 'string' ? filter.value : null}
                                            valueChanged={(e) => props.filterValueChanged(filter, e)}
                                            inputWidth="100%"
                                            size="medium"
                                            placeholder="Enter comma seperated list"
                                        />
                                    }
                                    {filter.type === BaseMapFilterEnum.DATE_RANGE &&
                                        <DateRageMapFilter 
                                            label={filter.name}
                                            value={typeof filter.value === 'string' ? filter.value : ""}
                                            valueChanged={(e) => props.filterValueChanged(filter, e)}
                                        />
                                    }
                                </div>
                            ))}
                        </Typography>
                        <div className="advanced-filters-button-wrapper">
                            <Button 
                                size="small" 
                                variant="contained"
                                onClick={props.toggleModal}
                            >Apply</Button>
                            <Button 
                                size="small" 
                                variant="text"
                                onClick={clearFilters}
                            >Clear</Button>
                        </div>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}